<template>
  <f7-page class="page-home has-footer" @page:afterin="pageMounted">
    <f7-navbar :sliding="false">
      <f7-nav-left>
        <f7-link panel-open="left" icon-f7="menu"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>KIỐTSỐ</f7-nav-title>
        <f7-nav-right>
            <f7-link href="https://alwaysopeninsafari.com/cskh-kts" external target="_blank">
                <img src="../assets/images/cskh2.png" style="height: 28px"/>
            </f7-link>
        </f7-nav-right>
    </f7-navbar>
    <div class="row" v-if="user_info.review_status === 1">
      <div class="col-100">
        <f7-swiper pagination :params="{autoplay: true, speed: 1000, spaceBetween: 20}">
          <f7-swiper-slide v-for="(adv, idx) in advertises" :key="idx">
            <a :href="adv.link" class="link external" target="_blank" v-if="adv.link" style="width: 100%">
              <template v-if="adv.type === 'image'">
                <div :style="`width: 100%; height: 155px; background-image: url(${adv.content}); background-repeat: no-repeat; background-position: top center; background-size: contain`"></div>
              </template>
              <div class="card theme-bg" v-else-if="adv.type === 'text'">
                <div class="card-content card-content-padding ">
                  <div class="row">
                    <div class="col align-self-center">
                      <h4 class="text-align-center mb-0">{{ adv.title }}</h4>
                      <span v-html="adv.content"></span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <template v-else-if="adv.type === 'image'">
              <div :style="`width: 100%; height: 155px; background-image: url(${adv.content}); background-repeat: no-repeat; background-position: top center; background-size: contain`"></div>
            </template>
            <div class="card theme-bg" v-else-if="adv.type === 'text'">
              <div class="card-content card-content-padding ">
                <div class="row">
                  <div class="col align-self-center">
                    <h4 class="text-align-center mb-0">{{ adv.title }}</h4>
                    <span v-html="adv.content"></span>
                  </div>
                </div>
              </div>
            </div>
          </f7-swiper-slide>
        </f7-swiper>
      </div>
    </div>
    <f7-row id="user-wallet" class="margin-bottom" v-if="user_info.review_status === 1">
      <f7-col width="50">
        <f7-link href="/nap-rut-usdt" class="display-block">
          <div class="card margin-bottom-half">
            <div class="card-content card-content-padding">
              <div class="row">
                <div class="col-auto no-padding-horizontal">
                  <div class="avatar avatar-40 bg-color-yellow text-color-white elevation-2 rounded-10-right">
                    <f7-icon f7="money_dollar"></f7-icon>
                  </div>
                </div>
                <div class="col">
                  <p class="text-muted size-12 no-margin-bottom">Số dư USDT</p>
                  <p>{{ user_info.wallet_balance | numeral('0,0[.]00') }}</p>
                </div>
              </div>
            </div>
          </div>
        </f7-link>
      </f7-col>
      <f7-col width="50">
        <f7-link href="/mua-credit" class="display-block">
          <div class="card margin-bottom-half">
            <div class="card-content card-content-padding">
              <div class="row">
                <div class="col-auto no-padding-horizontal">
                  <div class="avatar avatar-40 bg-color-green text-color-white elevation-2 rounded-10-right">
                    <f7-icon f7="cube"></f7-icon>
                  </div>
                </div>
                <div class="col">
                  <p class="text-muted size-12 no-margin-bottom">Số dư Credit</p>
                  <p>{{ user_info.system_credit | numeral('0,0') }}</p>
                </div>
              </div>
            </div>
          </div>
        </f7-link>
      </f7-col>
    </f7-row>
    <f7-block strong inset class="alert-danger margin-bottom box-shadow mt-0" v-if="user_info.feature_lock && user_info.review_status === 1">
      <strong><u>Lưu ý:</u></strong><br/> Tài khoản của bạn bị tạm khóa một số tính năng vì không đủ Credit. Vui lòng
                                          nạp thêm Credit để tiếp tục sử dụng dịch vụ. Xin cảm ơn!
    </f7-block>
    <f7-block strong inset class="alert-danger margin-bottom box-shadow mt-0" v-else-if="user_info.system_credit <= 90 && user_info.review_status === 1">
      <strong><u>Lưu ý:</u></strong><br/> Bạn đã gần hết Credit. Vui lòng nạp thêm để đảm bảo dịch vụ không bị gián
                                          đoạn. Xin cảm ơn!
    </f7-block>
    <f7-swiper pagination :params="{autoplay: {delay: 5000}, speed: 1000, spaceBetween: 20}" v-if="announcements.length > 0 && user_info.review_status === 1">
      <f7-swiper-slide v-for="(item, idx) in announcements" :key="idx">
        <div class="card alert-notice">
          <div class="card-content card-content-padding">
            <span v-html="item.content"></span>
          </div>
        </div>
      </f7-swiper-slide>
    </f7-swiper>
    <div class="row margin-bottom">
      <div class="col-100">
        <f7-swiper :params="{speed: 1000, spaceBetween: 10, slidesPerView: 2.5}">
          <f7-swiper-slide>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5>USDT</h5>
                <p class="text-color-crimson font-bold mb-0">
                  {{ exchange.usdt_buy | numeral('0,0') }}
                </p>
                <p class="text-color-forestgreen font-bold">
                  {{ exchange.usdt_sell | numeral('0,0') }}
                </p>
              </f7-card-content>
            </f7-card>
          </f7-swiper-slide>
          <f7-swiper-slide>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5>VÀNG SJC</h5>
                <p class="text-color-crimson font-bold mb-0">
                  {{ sjc_price.sell | numeral('0,0') }}
                </p>
                <p class="text-color-forestgreen font-bold">
                  {{ sjc_price.buy | numeral('0,0') }}
                </p>
              </f7-card-content>
            </f7-card>
          </f7-swiper-slide>
          <f7-swiper-slide>
            <f7-card>
              <f7-card-content class="text-align-center">
                <h5>VÀNG 9999</h5>
                <p class="text-color-crimson font-bold mb-0">
                  {{ g999_price.sell | numeral('0,0') }}
                </p>
                <p class="text-color-forestgreen font-bold">
                  {{ g999_price.buy | numeral('0,0') }}
                </p>
              </f7-card-content>
            </f7-card>
          </f7-swiper-slide>
        </f7-swiper>
      </div>
    </div>
    <f7-list inline-labels inset class="box-shadow">
      <f7-list-input
        label="Ngày xổ"
        type="datepicker"
        placeholder="Chọn ngày"
        :value="[this.drawdate]"
        @calendar:change="(values) => drawdate = values[0]"
        :calendar-params="{dateFormat: 'dd/mm/yyyy', locale: 'vi-VN', closeOnSelect: true, openIn: 'customModal'}">
        <f7-icon slot="media" f7="calendar"></f7-icon>
      </f7-list-input>
    </f7-list>
    <kqxs :draws="draws"></kqxs>
    <f7-popover class="popover-menu">
      <f7-list>
          <template v-if="(!_.isEmpty(user_info) && !_.isEmpty(user_info.mentor_info) && !_.isEmpty(user_info.mentor_info.telegram_username) && _.isNaN(parseFloat(user_info.mentor_info.telegram_username))) && user_info.review_status === 1">
              <f7-list-item no-chevron :link="`https://t.me/${user_info.mentor_info.telegram_username}`" title="Đại lý" external target="_blank" panel-close>
                  <f7-icon slot="media" class="telegram" f7="paperplane_fill"></f7-icon>
              </f7-list-item>
          </template>
          <f7-list-item no-chevron link="https://alwaysopeninsafari.com/cskh-kts" external target="_blank" title="CSKH" panel-close>
              <f7-icon slot="media" class="telegram" f7="paperplane_fill"></f7-icon>
          </f7-list-item>
      </f7-list>
    </f7-popover>
    <Footer id="main-footer" :active="'home'" v-if="user_info.review_status === 1"/>
  </f7-page>
</template>
<script>
import moment from "moment";
import Kqxs from "@/components/Kqxs";
import Footer from "@/components/Footer";
import numeral from 'numeral';
import { mapState } from 'vuex';

export default {
  components: {
    Kqxs,
    Footer
  },
  computed: {
    ...mapState(['user_info', 'exchange', 'customers', 'adv_popup_showed']),
    balance_vnd() {
      return numeral(this.user_info.wallet_balance * parseFloat(this.exchange.usdt_buy)).format('0,0')
    },
    sjc_price() {
      let sjc = this._.find(this.exchange.gold_prices, { code: 'SJC' });
      return !this._.isEmpty(sjc) ? { buy: sjc.buyingPrice, sell: sjc.sellingPrice } : { buy: 0, sell: 0 };
    },
    g999_price() {
      let gold = this._.find(this.exchange.gold_prices, { code: '999' });
      return !this._.isEmpty(gold) ? { buy: gold.buyingPrice, sell: gold.sellingPrice } : { buy: 0, sell: 0 };
    }
  },
  data() {
    return {
      announcements: [],
      draws: {},
      drawdate: new Date(),
      advertises: [],
      navigator: {
          userAgent: "Init"
      },
      popup: {}
    }
  },
  methods: {
    getAnnouncements() {
      this.$store.dispatch('getAnnouncements', {
        position: 'homepage',
        limit: 5
      }).then((data) => {
        this.announcements = data;
      });
    },
    getAdvertises() {
      this.$store.dispatch('getAnnouncements', {
        position: 'adv_top_homepage',
        limit: 5
      }).then((data) => {
        this.advertises = data;
      });
    },
    getPopup() {
      this.$store.dispatch('getAnnouncements', {
        position: 'adv_popup_homepage',
        limit: 1
      }).then((data) => {
        this.popup = this.$f7.notification.create({
          icon: '<i class="f7-icons">gift_fill</i>',
          title: '<b>'+data[0].title+'</b>',
          text: data[0].content,
          closeButton: true
        });
      });
    },
    getDraws() {
      this.$store.dispatch('getDrawByDate', {
        date: moment(this.drawdate).format('YYYY-MM-DD')
      }).then((data) => {
        this.draws = data;
        this._.each(this.draws.mn, (item, idx) => {
          this.draws.mn[idx].alias = idx;
        });
        this._.each(this.draws.mt, (item, idx) => {
          this.draws.mt[idx].alias = idx;
        });
      }).catch(() => {
        this.draws = {};
      });
    },
    toggleDarkMode() {
      this.$store.dispatch('toggleDarkMode');
    },
    getExchangePrice() {
      this.$store.dispatch('getExchangePrice').then((data) => {
        this.$store.commit('UPDATE_EXCHANGE', data);
      });
    },
    pageMounted(){
      this.navigator = navigator;
      this.getAdvertises();
      this.getExchangePrice();
      this.getAnnouncements();
      this.getPopup();

      if (this._.isEmpty(this.customers)) {
        this.$store.dispatch('getCustomers', {
          page: 1,
          limit: 1000
        });
      }

      if(!_.isEmpty(this.user_info)){
        if (this.user_info.server_region !== 'hanoi'){
          if (this.$moment(this.user_info.first_login).format('DD/MM/YYYY') === this.$moment(new Date()).format('DD/MM/YYYY')
            && !this.user_info.user_configs.display_mn
            && !this.user_info.user_configs.display_mn_mtay
            && !this.user_info.user_configs.display_mb
            && !this.user_info.user_configs.display_mt
            && !this.user_info.user_configs.display_mt_mtay
            && !this.user_info.user_configs.display_mt_buonme
            && !this.user_info.user_configs.display_mn_buonme
            && !this.user_info.user_configs.display_mb_buonme
            && !this.user_info.user_configs.display_mb_mtay
            && !this.user_info.user_configs.display_mb_ngan) {
            this.$f7router.navigate(`/cai-dat-cach-choi`);
          }
        }
      }

      setTimeout(() => {
        if (this.user_info.feature_lock && this.user_info.review_status === 1) {
          this.$f7.dialog.alert('Tài khoản của bạn bị tạm khóa một số tính năng vì không đủ Credit. Vui lòng nạp thêm Credit để tiếp tục sử dụng dịch vụ. Xin cảm ơn!', 'THÔNG BÁO');
        }
        else if (this.user_info.system_credit <= 90 && this.user_info.review_status === 1 && !this.user_info.user_configs.display_mt_buonme && !this.user_info.user_configs.display_mn_buonme && !this.user_info.user_configs.display_mb_buonme) {
          this.$f7.dialog.alert('Bạn đã gần hết Credit. Vui lòng nạp thêm để đảm bảo dịch vụ không bị gián đoạn. Xin cảm ơn!', 'THÔNG BÁO');
        }

        if (!this._.isEmpty(this.popup) && this.adv_popup_showed !== new Date().toISOString().slice(0, 10) && !!this.user_info.user_configs.display_advertise){
          this.$store.commit('UPDATE_ADV_POPUP');
          this.popup.open();
        }
      }, 2000);
    }
  },
  watch: {
    drawdate() {
      this.getDraws();
    }
  }
};
</script>
<style>
.font-bold {
  font-weight : bold;
}
.alert-notice {
  color            : #664D03 !important;
  background-color : #FFF3CD !important;
  border-color     : #FFECB5 !important;
}
.alert-danger {
  color            : #842029 !important;
  background-color : #F8D7DA !important;
  border-color     : #F5C2C7 !important;
}
.max-width-100 {
  max-width : 100%;
}
.v-step__button {
  width : auto;
}
.v-step__header {
  border-top-left-radius  : var(--fimobile-rounded) !important;
  border-top-right-radius : var(--fimobile-rounded) !important;
}
.v-step {
  border-radius : var(--fimobile-rounded) !important;
}
</style>
